
import { Base } from '../base-component';

import './contact-accordion-single.component.scss';

export class ContactAccordionSingle extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){}

	bindEvents() {}

}


// WEBPACK FOOTER //
// ./components/contact-accordion-single/contact-accordion-single.component.ts